import { Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../../routes/createPathParameter';
import { createdResponse, updatedResponse, removedResponse } from '../../../routes/defaultResponses';
import { userTableSchema } from '../../user/userTableSchema';
import { surveyWorkflowEmployeeTableSchema } from './surveyWorkflowEmployeeTableSchema';

export const surveyWorkflowEmployeePaths = {
    '/api/surveys/{surveyId}/workflowEmployees': {
        parameters: [createPathGuidParameter('surveyId')],
        get: {
            operationId: 'surveyWorkflowControllers.getAll',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                items: Type.Array(
                                    Type.Intersect([
                                        Type.Pick(surveyWorkflowEmployeeTableSchema, ['id', 'remarks', 'shouldBeNotified', 'workflowRole']),
                                        Type.Object({
                                            user: Type.Pick(userTableSchema, ['id', 'firstName', 'lastName']),
                                        }),
                                    ]),
                                ),
                            }),
                        },
                    },
                },
            },
        },
        post: {
            operationId: 'surveyWorkflowControllers.createSurveyWorkflowEmployee',
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Pick(surveyWorkflowEmployeeTableSchema, ['userId', 'workflowRole', 'shouldBeNotified', 'remarks']),
                    },
                },
            },
            responses: {
                ...createdResponse,
            },
        },
    },
    '/api/surveys/{surveyId}/workflowEmployees/{workflowEmployeeId}': {
        parameters: [createPathGuidParameter('surveyId'), createPathGuidParameter('workflowEmployeeId')],
        post: {
            operationId: 'surveyWorkflowControllers.updateSurveyWorkflowEmployee',
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Pick(surveyWorkflowEmployeeTableSchema, ['shouldBeNotified']),
                    },
                },
            },
            responses: {
                ...updatedResponse,
            },
        },
        delete: {
            operationId: 'surveyWorkflowControllers.deleteSurveyWorkflowEmployee',
            responses: {
                ...removedResponse,
            },
        },
    },
} as const;
